import React from 'react'

const AutoCloseAction = () => (
  <p>
    The auto closed notification email will be sent to tickets primary contact
  </p>
)

export default AutoCloseAction
